import React from 'react';
import { Reveal } from './ui/Reveal';
import { proofStats } from '../data/content';
export function SocialProof() {
  return <section aria-label="Todo lo que necesitás en un solo lugar" className="border-b border-line bg-accent" data-id="element-261" data-mp="3ltm57xko2z6u">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-5" data-id="element-262" data-mp="36xog2z95uv44">
        <p className="text-center font-display text-xs font-bold uppercase tracking-[0.2em] text-canvas/70" data-id="element-263" data-mp="3bvg77r1zed79">
          Todo lo que necesitás. En un solo lugar.
        </p>
        <dl className="mt-3 grid grid-cols-2 gap-x-6 gap-y-4 md:grid-cols-4 md:divide-x md:divide-canvas/20" data-id="element-264" data-mp="8ehkf975oap3">
          {proofStats.map((stat, i) => <Reveal key={stat.label} delay={i * 0.03} className="md:px-6 md:first:pl-0" data-id="element-265" data-mp="3psd7ej3zp70t" data-mpi={i}>
              <dt className="font-display text-2xl md:text-3xl font-black text-canvas" data-id="element-266" data-mp="md7hwpxw0cdz">
                {stat.value}
              </dt>
              <dd className="mt-0.5 text-sm font-semibold text-canvas/80" data-id="element-267" data-mp="r60id1mboyk9">
                {stat.label}
              </dd>
            </Reveal>)}
        </dl>
      </div>
    </section>;
}